<app-header></app-header>
<div
  class="d-flex flex-column align-items-center justify-content-center app-container"
>
  <div class="maxwidth-class">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
